var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-list"},_vm._l((_vm.projects),function(item){return _c('product-list-item',{attrs:{"project":item,"img-height":_vm.imgHeight}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }